module.exports = __webpack_public_path__ + "img/visa-secure.d2ca760c.jpg";